import { render, staticRenderFns } from "./dispatchingUnits.vue?vue&type=template&id=cb024678&scoped=true&"
import script from "./dispatchingUnits.vue?vue&type=script&lang=js&"
export * from "./dispatchingUnits.vue?vue&type=script&lang=js&"
import style0 from "./dispatchingUnits.vue?vue&type=style&index=0&id=cb024678&prod&lang=scss&"
import style1 from "./dispatchingUnits.vue?vue&type=style&index=1&id=cb024678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb024678",
  null
  
)

export default component.exports